var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{attrs:{"absolute":"","color":"transparent","flat":"","height":"85"}})
}
var staticRenderFns = []

export { render, staticRenderFns }